module.exports = __webpack_public_path__ + "static/media/bg-desk.2394e78a.svg";